import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {},
    dates: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    calendarTodayIcon: {
        marginRight: theme.spacing(1)
    },
    divider: {
        margin: theme.spacing(2, 0),
        backgroundColor: '#dfdfdf',
        margin: '5px 0px',
    },
    userName: {
        color: '#54678C'
    },
}));

const Header = props => {
    const { className, ...rest } = props;
    const classes = useStyles();
    const jobApplication = useSelector(state => state.jobApplication);
    const firstName = props?.firstName? props?.firstName : jobApplication.applicantFirstName;
    const middleName = props?.middleName ? props?.middleName : jobApplication.applicantMiddleName;
    const lastName = props?.lastName ? props?.lastName: jobApplication.applicantLastName;

    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <Grid container justify="space-between" spacing={3}>
                <Grid item lg={12} xs={12}>
                    <Typography className={classes.userName} component="h3" align="center" color="primary" gutterBottom variant="h3">
                        Welcome :
                        {firstName !== null && firstName !== undefined &&
                            firstName !== "" ?
                            (" " + firstName + " ") : " "
                        }
                        {middleName !== null && middleName !== undefined &&
                            middleName !== "" ?
                            (middleName + " ") : ""
                        }
                        {lastName !== null && lastName !== undefined &&
                            lastName !== "" ?
                            lastName : ""
                        }
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

Header.propTypes = {
    className: PropTypes.string
};

Header.defaultProps = {};

export default Header;